import { render } from "./WizardAutomationPlant.vue?vue&type=template&id=c0025736&ts=true"
import script from "./WizardAutomationPlant.ts?vue&type=script&lang=ts"
export * from "./WizardAutomationPlant.ts?vue&type=script&lang=ts"

import "./WizardAutomationPlant.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__